// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"InputPassword_pattern-gradient__Ex4YG","forgot":"InputPassword_forgot__+cwq6"};